import { makeObservable, observable } from 'mobx';
import { IModel, Model } from './Model';

export interface IPrognosisScoreModel extends IModel {
  prognosisScoreId: number;
  name: string;
  description: string;
}

export class PrognosisScoreModel
  extends Model
  implements Record<keyof IPrognosisScoreModel, any>
{
  @observable prognosisScoreId: number;
  @observable name: string;
  @observable description: string;

  constructor(params: Partial<IPrognosisScoreModel> = {}) {
    super(params);
    this.prognosisScoreId = params.prognosisScoreId ?? 0;
    this.name = params.name ?? '';
    this.description = params.description ?? '';
    makeObservable(this);
  }
}
